import { useEffect, useMemo, useState, useCallback } from "react";
import { VideoGuideGroup } from "api/interfaces/managerInterface.interface";
import useHelpGuideApi, {
  HelpGuide,
  HelpGuideGroup,
} from "hook/useHelpGuideApi";
import VideoGuidePresenter from "./VideoGuidePresenter";
import { videoGuideOptions } from "utils/options";

const mapGuidesToGroups = (
  groups: HelpGuideGroup[],
  guides: HelpGuide[]
): VideoGuideGroup[] =>
  groups.map((group) => {
    const videoGuideList = guides
      .filter((guide) => guide.groupId === group.groupId)
      .sort((a, b) => a.position - b.position);

    return {
      groupId: group.groupId,
      name: group.groupName,
      position: group.sortOrder,
      category: videoGuideOptions[0].value, // TODO: 동적 카테고리 처리 필요시 수정
      videoGuideList,
      layout: group.layout,
    };
  });

export default function VideoGuides(): JSX.Element {
  const [isYoutubeModalOpen, setYoutubeModalOpen] = useState(false);
  const [isPdfModalOpen, setPdfModalOpen] = useState(false);
  const [selectedGuide, setSelectedGuide] = useState<HelpGuide | null>(null);

  const [helpGuides, setHelpGuides] = useState<HelpGuide[]>([]);
  const [helpGuideGroups, setHelpGuideGroups] = useState<HelpGuideGroup[]>([]);

  const { getHelpGuideGroups, getHelpGuides } = useHelpGuideApi();

  const openModal = useCallback((type: "youtube" | "pdf", guide: HelpGuide) => {
    setSelectedGuide(guide);
    type === "youtube" ? setYoutubeModalOpen(true) : setPdfModalOpen(true);
  }, []);

  const closeModal = useCallback((type: "youtube" | "pdf") => {
    setSelectedGuide(null);
    type === "youtube" ? setYoutubeModalOpen(false) : setPdfModalOpen(false);
  }, []);

  useEffect(() => {
    const fetchData = async () => {
      const [groups, guides] = await Promise.all([
        getHelpGuideGroups(),
        getHelpGuides(),
      ]);
      setHelpGuideGroups(groups);
      setHelpGuides(guides);
    };
    fetchData();
  }, []);

  const helpGuidesByGroups = useMemo(
    () =>
      mapGuidesToGroups(helpGuideGroups, helpGuides).filter(
        (group) => group.videoGuideList.length > 0
      ),
    [helpGuideGroups, helpGuides]
  );

  return (
    <VideoGuidePresenter
      helpGuidesByGroups={helpGuidesByGroups}
      isYoutubeModal={isYoutubeModalOpen}
      isPdfModal={isPdfModalOpen}
      selectedGuideItem={selectedGuide}
      openYoutube={(item) => openModal("youtube", item)}
      openPdfModal={(item) => openModal("pdf", item)}
      closeYoutube={() => closeModal("youtube")}
      closePdfModal={() => closeModal("pdf")}
    />
  );
}
